module.exports = __webpack_public_path__ + "static/media/hr.4680d632.svg";